import { useCallback } from 'react';
import { Module, ScopeEnum } from 'src/domain';
import { useDiscardChangesModule } from 'src/hooks/discard-changes/useDiscardChangesModule';
import { useInheritance } from 'src/hooks/inheritance';
import { useChangesSnackbar } from 'src/hooks/snackbar/useChangesSnackbar';
import { useUpdateSplitLevel } from 'src/hooks/split-levels/useUpdateSplitLevel';
import { useScope } from 'src/hooks/useScope';

export const useUpdateModuleInheritance = (module: Module, standalone = true) => {
    const { updateSplitLevel, loading } = useUpdateSplitLevel();
    const discardChanges = useDiscardChangesModule(module);
    const inheritance = useInheritance();
    const scope = useScope();
    const showSnackbar = useChangesSnackbar();

    const updateInheritance = useCallback(async (): Promise<void> => {
        if (!inheritance || (scope !== ScopeEnum.STORE && standalone)) return;

        try {
            if (scope === ScopeEnum.STORE) {
                await updateSplitLevel(inheritance);
            }
            await discardChanges();
            if (standalone) showSnackbar();
        } catch (error: unknown) {
            if (!standalone) throw error;
            showSnackbar(error);
        }
    }, [inheritance, scope, updateSplitLevel, discardChanges, standalone, showSnackbar]);

    return { updateInheritance, loading };
};
